<template>
  <div v-if="notifications && notifications.length > 0">
    <div v-if="notifications.length > 0">
      <notification-alert
        v-for="notification in notifications"
        v-on:dismiss="onNotificationDismiss"
        :item="notification"
        :key="notification.id"
      />
    </div>
  </div>
</template>

<script>
import Notification from '@/services/notification'
import NotificationAlert from '@/components/notifications/notification-alert'

export default {
  components: {
    NotificationAlert
  },
  computed: {
    notifications: function() {
      return Notification.getNotifications()
    }
  },
  methods: {
    onNotificationDismiss: function(id) {
      Notification.removeNotificationById(id)
    }
  }
}
</script>
